var _path, _path2, _path3, _circle, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path5, _path6, _path7, _path8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageNotFound = function SvgPageNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8526fe",
    d: "M596.677 246.038v-18.19a13.08 13.08 0 0 0-13.08-13.08h-36.166a13.08 13.08 0 0 1-13.079-13.08v-18.19c0-7.224 15.856-13.08 23.08-13.08h1.457a13.08 13.08 0 0 0 13.08-13.08v-18.19a13.08 13.08 0 0 0-13.08-13.08H116.982a13.08 13.08 0 0 0-13.08 13.08v18.19a13.08 13.08 0 0 0 13.08 13.08 13.08 13.08 0 0 1 13.08 13.08v18.19a13.08 13.08 0 0 1-13.08 13.08h-50.58a13.08 13.08 0 0 0-13.079 13.08v18.19a13.08 13.08 0 0 0 13.08 13.08h19.846a13.08 13.08 0 0 1 13.08 13.08v18.19a13.08 13.08 0 0 1-13.08 13.08h-.048a13.08 13.08 0 0 0-13.08 13.08v18.19a13.08 13.08 0 0 0 13.08 13.08h2.872a13.08 13.08 0 0 1 13.079 13.08v18.19a13.08 13.08 0 0 1-13.08 13.08H71.949a13.08 13.08 0 0 0-13.08 13.08v18.19a13.08 13.08 0 0 0 13.08 13.08h483.963a13.08 13.08 0 0 0 13.08-13.08v-18.19a13.08 13.08 0 0 0-13.08-13.08h-11.34a13.08 13.08 0 0 1-13.08-13.08v-18.19a13.08 13.08 0 0 1 13.08-13.08h26.74a13.08 13.08 0 0 0 13.079-13.08v-18.19a13.08 13.08 0 0 0-13.08-13.08H563.2a13.08 13.08 0 0 1-13.08-13.08v-18.19a13.08 13.08 0 0 1 13.08-13.08h20.398a13.08 13.08 0 0 0 13.08-13.08",
    className: "page-not-found_svg__colordbe8ec page-not-found_svg__svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8a353",
    d: "M221.782 214.165a25.03 25.03 0 0 1-25.008 25.02h-93.45a19.282 19.282 0 0 1-4.1-38.125 22.246 22.246 0 0 1 22.169-20.78 21.6 21.6 0 0 1 6.725 1.074 35.102 35.102 0 0 1 65.342 8.05 24.978 24.978 0 0 1 28.323 24.76m0 0",
    className: "page-not-found_svg__colorf9ae2b page-not-found_svg__svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "m384.28 361.08-18.578-27.62a79.998 79.998 0 1 0-23.114 14.348l18.11 26.804a13.594 13.594 0 0 0 23.582-13.532",
    className: "page-not-found_svg__color409cb5 page-not-found_svg__svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 312.733,
    cy: 273.513,
    r: 57.048,
    fill: "#ad59d4",
    className: "page-not-found_svg__coloree781d page-not-found_svg__svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e08f14",
    d: "M312.733 216.465a57.5 57.5 0 0 0-8.139.588 57.043 57.043 0 0 1 0 112.92 57.046 57.046 0 1 0 8.139-113.508",
    className: "page-not-found_svg__colore06714 page-not-found_svg__svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.177,
    cy: 274.625,
    r: 8.829,
    fill: "#d8a353",
    className: "page-not-found_svg__colorf9ae2b page-not-found_svg__svgShape"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.279,
    cy: 262.647,
    r: 6.112,
    fill: "#e08f14",
    className: "page-not-found_svg__colore06714 page-not-found_svg__svgShape"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.149,
    cy: 250.639,
    r: 4.075,
    fill: "#e08f14",
    className: "page-not-found_svg__colore06714 page-not-found_svg__svgShape"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.658,
    cy: 304.906,
    r: 4.075,
    fill: "#e08f14",
    className: "page-not-found_svg__colore06714 page-not-found_svg__svgShape"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.207,
    cy: 289.982,
    r: 5.513,
    fill: "#d8a353",
    className: "page-not-found_svg__colorf9ae2b page-not-found_svg__svgShape"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.216,
    cy: 326.179,
    r: 3.132,
    fill: "#30a395",
    className: "page-not-found_svg__color3086a3 page-not-found_svg__svgShape"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.913,
    cy: 239.928,
    r: 3.132,
    fill: "#30a395",
    className: "page-not-found_svg__color3086a3 page-not-found_svg__svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#30a395",
    d: "M371.01 307.043a62 62 0 0 1-6.951 11.388 67.6 67.6 0 0 1-9.426 9.625 70 70 0 0 1-11.328 7.438 64.1 64.1 0 0 1-26.11 7c-2.27.02-4.534.104-6.794-.034a61 61 0 0 1-6.737-.752 59.1 59.1 0 0 1-24.675-10.04 78.5 78.5 0 0 0 25.087 6.946 71.9 71.9 0 0 0 25.512-2.09 75 75 0 0 0 12.046-4.417 81.4 81.4 0 0 0 11.106-6.518 84 84 0 0 0 9.85-8.445 94 94 0 0 0 8.42-10.101M246.835 286.85a62.38 62.38 0 0 1 .722-35.164 65.6 65.6 0 0 1 7.638-16.267 65 65 0 0 1 5.437-7.204 68 68 0 0 1 6.324-6.448 73 73 0 0 1 7.149-5.522c1.28-.795 2.513-1.664 3.838-2.383l1.963-1.118 2.02-1.013c1.336-.691 2.745-1.235 4.117-1.847 1.414-.516 2.796-1.112 4.239-1.543a62 62 0 0 1 8.719-2.226 66 66 0 0 1 17.852-.694 61.4 61.4 0 0 1 17.143 4.308 75.4 75.4 0 0 0-17.262-2.348 72.2 72.2 0 0 0-17.103 1.791 69 69 0 0 0-16.002 5.942 72 72 0 0 0-7.328 4.364 70 70 0 0 0-6.693 5.28 69.1 69.1 0 0 0-19.106 27.927 72.04 72.04 0 0 0-3.667 34.165",
    className: "page-not-found_svg__color3086a3 page-not-found_svg__svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M203.269 332.512v23.165c0 20.119 1.22 21.643 22.861 23.776v8.536h-71.327v-8.536c22.86-2.133 24.385-3.962 24.385-24.081v-22.86H98.716v-9.145c28.958-41.15 60.354-85.654 90.836-128.024h13.717V317.88h29.872v14.633Zm-24.08-105.162c-19.204 28.042-40.542 59.133-61.574 90.53h61.573Zm325.237 105.162v23.165c0 20.119 1.22 21.643 22.862 23.776v8.536H455.96v-8.536c22.861-2.133 24.385-3.962 24.385-24.081v-22.86h-80.47v-9.145c28.957-41.15 60.353-85.654 90.835-128.024h13.716V317.88H534.3v14.633Zm-24.08-105.162c-19.204 28.042-40.541 59.133-61.573 90.53h61.572Z",
    className: "page-not-found_svg__color409cb5 page-not-found_svg__svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8a353",
    d: "M552.439 143.699a32.97 32.97 0 0 1-32.94 32.954H396.41a25.398 25.398 0 0 1-5.4-50.215 29.3 29.3 0 0 1 29.2-27.37 28.4 28.4 0 0 1 8.857 1.415 46.234 46.234 0 0 1 86.066 10.602 32.9 32.9 0 0 1 37.305 32.614m-.173 257.676a25.03 25.03 0 0 1-25.009 25.02h-93.45a19.282 19.282 0 0 1-4.099-38.125 22.246 22.246 0 0 1 22.168-20.78 21.6 21.6 0 0 1 6.725 1.074 35.102 35.102 0 0 1 65.342 8.05 24.978 24.978 0 0 1 28.323 24.76m0 0",
    className: "page-not-found_svg__colorf9ae2b page-not-found_svg__svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b9dbd7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M119.225 119.327h32.303M119.225 128.637h32.303M119.225 137.948h32.303M273.595 395.257h32.303M273.595 404.568h32.303M273.595 413.878h32.303M536.115 271.982h32.302M536.115 281.293h32.302M536.115 290.603h32.302",
    className: "page-not-found_svg__colorStrokeb9d4db page-not-found_svg__svgStroke"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.914,
    cy: 399.628,
    r: 16.428,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.589,
    cy: 373.267,
    r: 8.557,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.12,
    cy: 411.536,
    r: 7.406,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.92,
    cy: 389.583,
    r: 4.936,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.301,
    cy: 414.559,
    r: 11.833,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.282,
    cy: 162.289,
    r: 16.428,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.694,
    cy: 178.717,
    r: 7.406,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.615,
    cy: 150.456,
    r: 11.833,
    fill: "#b9dbd7",
    className: "page-not-found_svg__colorb9d4db page-not-found_svg__svgShape"
  })));
};
export default SvgPageNotFound;